import React from 'react'
import { Grid, Paper } from '@material-ui/core'
import { useSelector } from 'react-redux';

import { useStyles } from './reportStyles';
import { BarChartAlarmsType } from '../charts/BarChartAlarmsType';



export const ReportChartsLights = () => {
    const classes = useStyles();
    const {data} = useSelector(state => state.print);
    let {7:redLightning=[],8:orangeLightning=[],9:yellowLightning=[]}= data;
    if(yellowLightning===undefined){
        yellowLightning.rayos_minuto_ca=[]
    }
    if(orangeLightning===undefined){
        orangeLightning.rayos_minuto_ma=[]
    }    
    if(redLightning===undefined){
        redLightning.rayos_minuto_aoc=[]
    }  
    return (
        <>
            <Grid item xs={12} md={12} lg={12} id="charts-report">
                <Paper className={classes.paper}>
                    <BarChartAlarmsType  dataChart={yellowLightning.rayos_minuto_ca} type={1}/>
                </Paper>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <Paper className={classes.paper}>
                    <BarChartAlarmsType  dataChart={orangeLightning.rayos_minuto_ma} type={2}/>
                </Paper>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <Paper className={classes.paper}>
                    <BarChartAlarmsType  dataChart={redLightning.rayos_minuto_aoc} type={3}/>
                </Paper>
            </Grid>

            {/* <Grid item xs={12} md={12} lg={12}>
                <div id="content">
                    <div id="pageFooter">Página 2 </div>
                </div>
            </Grid> */}
            
        </>
    )
}
